import * as React from 'react';
import { GlobCompanies } from '../../../../MedicareProAPI/Entities/Glob/GlobCompanies';
import { GlobCompaniesRepository } from '../../../../MedicareProAPI/Repositories/Glob/GlobCompaniesRepository';
import { MultiSelectModal } from './MultiSelectModal';
import type { SelectMap } from '../../../Utilities/SelectMap';

export interface IndPolicyCompanySelectProps {
  userAccessToken: string;
  userId: number;
  disabled?: boolean;

  onChange?: (planTypes: string[]) => void;

  value: string[];
}

export const IndPolicyCompanySelect = (props: IndPolicyCompanySelectProps): React.JSX.Element => {
  const [value, setValue] = React.useState<string[]>(props.value);
  const [companyOptions, setCompanyOptions] = React.useState<SelectMap[]>();
  const globCompaniesRepository = new GlobCompaniesRepository();
  globCompaniesRepository.setAccessToken(props.userAccessToken);

  React.useEffect(() => {
    let alive = true;

    globCompaniesRepository.getGlobCompanies().then((response: any) => {
      const items = response.getItems?.() ?? response ?? [];
      const options: SelectMap[] = items.map((c: any) => ({
        value: c.getCompanyId?.(),
        label: c.getCompanyName?.(),
      }));

      // Optional: sort by label
      options.sort((a, b) => a.label.localeCompare(b.label));
      console.log(options);
      if (alive) setCompanyOptions(options);
    });

    return () => {
      alive = false;
    };
  }, []);

  return (
    <>
      <div>
        {companyOptions && (
          <MultiSelectModal
            disabled={props.disabled}
            value={value}
            options={companyOptions}
            modalSaveButtonLabel="Save Changes"
            modalTitle="Select"
            buttonSelectLabel="Choose"
            buttonEditLabel="Edit"
            onChange={(newValue) => {
              setValue(newValue);

              if (props.onChange) {
                props.onChange(newValue);
              }
            }}
            search={true}
          />
        )}
      </div>
    </>
  );
};
